<template>
    <div class="flex flex-col items-center justify-center h-full text-center gap-4 py-12 px-6">
        <div class="text-4xl font-bold text-surface-900 dark:text-surface-0">Graph not found</div>
        <p class="text-surface-700 dark:text-surface-100 text-lg max-w-xl">
            The graph you are trying to open does not exist or you no longer have access to it.
        </p>
        <Button label="Back to home" icon="pi pi-home" rounded @click="goHome" />
    </div>
</template>

<script setup>
import { useStore } from "vuex";

const store = useStore();

const goHome = async () => {
    store.dispatch("repoStore/setSelectedSpace", null);
    store.dispatch("repoStore/setSelectedGraph", null);
    await store.dispatch("repoStore/loadWorkspaces");
};
</script>
